import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

/**
 * @file search类型filter
 * @author alfielv
 */
import _ from 'lodash';
import React, { useMemo, useState, useCallback, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { Icon } from '@tencent/spaui';
import FilterAutoComplete from './FilterAutoComplete';
import FilterInput from './FilterInput';
import FilterSelect from '../components/Select';
var INPUT_DEBOUNCE_DELAY = 500; // 防抖延迟
// 筛选搜索项

export default /*#__PURE__*/React.memo(function (props) {
  var title = props.title,
      name = props.name,
      defaultValue = props.defaultValue,
      value = props.value,
      autoComplete = props.autoComplete,
      selectOnly = props.selectOnly,
      _props$config = props.config,
      config = _props$config === void 0 ? {} : _props$config,
      nameConfig = props.nameConfig,
      rules = props.rules,
      searchFunction = props.searchFunction,
      onFilterDataUpdate = props.onFilterDataUpdate,
      _props$clearable = props.clearable,
      clearable = _props$clearable === void 0 ? true : _props$clearable;

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1]; // 输入值


  var _useState3 = useState('normal'),
      _useState4 = _slicedToArray(_useState3, 2),
      inputStatus = _useState4[0],
      setInputStatus = _useState4[1]; // 校验结果


  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      errorMessage = _useState6[0],
      setErrorMessage = _useState6[1]; // 校验失败提示信息


  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      active = _useState8[0],
      setActive = _useState8[1]; // 输入框是否激活态
  // 输入函数防抖处理。


  var handleFilterDataDelayUpdate = useMemo(function () {
    if (_.isFunction(onFilterDataUpdate)) {
      return _.debounce(onFilterDataUpdate, INPUT_DEBOUNCE_DELAY);
    }

    return null;
  }, [onFilterDataUpdate]); // 清空筛选项

  var handleClear = useCallback(function () {
    onFilterDataUpdate === null || onFilterDataUpdate === void 0 ? void 0 : onFilterDataUpdate({
      type: 'DELETE',
      key: name
    });
    setSearchValue('');
    setInputStatus('normal');
    setErrorMessage('');
  }, [onFilterDataUpdate, name]); // 选择字段名下拉项

  var handleNameChange = useCallback(function (value) {
    // 联动清空数据
    onFilterDataUpdate === null || onFilterDataUpdate === void 0 ? void 0 : onFilterDataUpdate({
      type: 'UPDATE_AND_DELETE',
      key: value,
      value: '',
      deleteKeys: [name]
    });
  }, [name, onFilterDataUpdate]);
  var nameElement = nameConfig ? /*#__PURE__*/React.createElement(FilterSelect, {
    config: nameConfig,
    setActive: setActive,
    value: name,
    onChange: handleNameChange
  }) : title; // 外部更新formData（比如reset），同步给searchValue

  var searchValueRef = useRef(searchValue);
  searchValueRef.current = searchValue;
  useEffect(function () {
    if (!_.isEqual(value, searchValueRef.current)) {
      setSearchValue(value);
    }
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    id: "filter-item__".concat(name),
    className: classNames('filter-item', {
      'filter-item-active': active,
      'filter-item-error': inputStatus === 'error'
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-item-key"
  }, nameElement), /*#__PURE__*/React.createElement("span", {
    className: "filter-item-val"
  }, autoComplete ? /*#__PURE__*/React.createElement(FilterAutoComplete, {
    name: name,
    searchValue: searchValue,
    setSearchValue: setSearchValue,
    title: title,
    config: config,
    selectOnly: selectOnly,
    active: active,
    setActive: setActive,
    searchFunction: searchFunction,
    onFilterDataUpdate: onFilterDataUpdate,
    handleFilterDataDelayUpdate: handleFilterDataDelayUpdate
  }) : /*#__PURE__*/React.createElement(FilterInput, {
    name: name,
    title: title,
    searchValue: searchValue,
    setSearchValue: setSearchValue,
    inputStatus: inputStatus,
    setInputStatus: setInputStatus,
    errorMessage: errorMessage,
    setErrorMessage: setErrorMessage,
    handleFilterDataDelayUpdate: handleFilterDataDelayUpdate,
    rules: rules,
    setActive: setActive,
    config: config
  })), clearable && /*#__PURE__*/React.createElement("span", {
    className: "filter-item-clear-btn",
    onClick: handleClear
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "close",
    className: "meta-clear"
  })));
});